import React from 'react';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import TextSectionSkeleton from '../../../../components/skeletons/TextSectionSkeleton';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';
import useMediaQuery from '../../../../utils/hooks/mediaQuery.hook';
import ImageContainer from '../../../../components/ImageContainer';
import { ARTICLE_IMAGE_SIZE, ARTICLE_IMAGE_SM_SIZE } from '../../constants';

const ArticleCardSkeleton = () => {
  const { isMobile } = useMediaQuery();

  const size = isMobile ? ARTICLE_IMAGE_SM_SIZE : ARTICLE_IMAGE_SIZE;
  const imageDimensions = { width: size, height: size };

  return (
    <Card className="mx-auto">
      <CardBody className="p-0 p-md-3">
        <Row>
          <Col xs={5} md={12} className="pe-0 px-md-3">
            <div className="text-center mb-md-5">
              <ImageContainer
                className="m-0"
                size={imageDimensions}
                alt="name"
              />
            </div>
          </Col>
          <Col xs={7} md={12} className="px-md-3">
            <Row>
              <Col xs={12}>
                <TextSectionSkeleton />
                <br />
              </Col>
              <Col xs={12}>
                <Row>
                  <Col xs={12}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <SkeletonElement type="label-short" />
                      {isMobile && <SkeletonElement type="label-short" />}
                    </div>
                  </Col>
                  {isMobile && (
                    <Col xs={12}>
                      {isMobile && <SkeletonElement type="button" />}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default ArticleCardSkeleton;
